<template>
  <div class="main">
    <div class="container">
      <div class="search-container">
        <template
          class="search-container"
          v-if="!results.reduce((acumulador, numero) => { return acumulador += numero.topicos.length;}, 0) || this.$route.query.termo == ''"
        >
          <header class="page-header">
            <h4>Resultados da pesquisa</h4>
            <p class="page-header-description">Nenhum resultado para "{{this.$route.query.termo}}"</p>
          </header>
          <div class="search-results">
            <section class="search-results-column">
              <p>
                Nenhum resultado para "{{this.$route.query.termo}}".
                <router-link :to="`/category/0/`">Navegar pela Base de Conhecimento</router-link>
              </p>
            </section>
          </div>
        </template>
        <template class="search-container" v-else>
          <header class="page-header">
            <h4>Resultados da pesquisa</h4>
            <p
              class="page-header-description"
            >{{results.reduce((acumulador, result) => { return acumulador += result.topicos.length}, 0)}} resultado{{results.length > 1 ? "s" : ""}} para "{{this.$route.query.termo}}"</p>
          </header>

          <div class="search-results">
            <section class="search-results-column">
              <ul
                class="search-results-list"
                v-for="(result,resultsIndex) in results"
                :key="resultsIndex"
              >
                <li
                  class="search-result"
                  v-for="(topico,topicoIndex) in results[resultsIndex].topicos"
                  :key="topicoIndex"
                >
                  <router-link
                    :to="`/category/${resultsIndex}/article/${topicoIndex}/`"
                    class="section"
                  >{{topico.title}}</router-link>
                  <div
                    class="search-result-description"
                    v-html="topico.content.split('. ')[0].slice(0, 100).concat('...')"
                  ></div>
                </li>
              </ul>
            </section>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { configs } from "@/assets/data/data.json";
export default {
  name: "Resultados",
  data: function() {
    return {
      results: []
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.results = configs[this.$parent.site].categorias.map(
        (categoria, index) => {
          return {
            indice: index,
            topicos: categoria.topicos.filter(topico =>
              topico.content
                .toLowerCase()
                .includes(this.$route.query.termo.toLowerCase())
            )
          };
        }
      );
    }
  }
};
</script>
<style lang="scss">
.page-header {
  h4 {
    color: rgba(0, 0, 0, 1);
    font-size: 17px;
    text-transform: uppercase;
    margin-bottom: 10px;
    font-weight: 700;
  }
  .page-header-description {
    color: #999;
    font-size: 12px;
    font-style: normal;
  }
}
.search-results-list {
  list-style: none;
  padding: 0;
  li {
    border-bottom: 1px solid #999;
    padding: 20px 0;
    list-style-type: none;
    a {
      font-weight: 700;
      color: rgba(0, 0, 0, 1);
      font-size: 17px;
      text-transform: uppercase;
      &:hover {
        color: rgba(0, 0, 0, 1);
      }
    }
    .search-result-description {
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      font-size: 14px;
      margin-top: 15px;
      word-break: break-word;
    }
  }
}
.search-results-column {
  a {
    font-weight: 700;
    color: rgba(0, 0, 0, 1);
    &:hover {
      color: rgba(0, 0, 0, 1);
    }
  }
}
</style>